import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReactiveFormsModule } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { type PrincipleSettingsUpdate } from '@principle-theorem/principle-bridge-core';
import { NgJsonEditorModule, JsonEditorOptions } from 'ang-jsoneditor';

export interface IEditBridgeSettingsDialogData {
  settings?: PrincipleSettingsUpdate;
}

export interface IEditBridgeSettingsDialogResult {
  settings: PrincipleSettingsUpdate;
}

interface ISettingsForm {
  settings: PrincipleSettingsUpdate;
}

@Component({
  selector: 'pr-edit-bridge-settings-dialog',
  templateUrl: './edit-bridge-settings-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatToolbarModule,
    NgJsonEditorModule,
    ReactiveFormsModule,
  ],
})
export class EditBridgeSettingsDialogComponent {
  private _dialogRef =
    inject<
      MatDialogRef<
        EditBridgeSettingsDialogComponent,
        IEditBridgeSettingsDialogResult
      >
    >(MatDialogRef);
  private _data = inject<IEditBridgeSettingsDialogData>(MAT_DIALOG_DATA);

  form = new TypedFormGroup<ISettingsForm>({
    settings: new TypedFormControl<PrincipleSettingsUpdate>(),
  });
  editorOptions = new JsonEditorOptions();

  constructor() {
    this.editorOptions.expandAll = true;
    if (this._data.settings) {
      this.form.patchValue({ settings: this._data.settings });
    }
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }
    this._dialogRef.close(this.form.getRawValue());
  }
}
